const
	_U = 'undefined';
			

class Router {
	constructor(setup) {
		this.setup = setup;

		const { routes, routeSelectorMask, routesContainer, containerSelector, links, linksContainer, linkSelector, ajaxService } = setup;

		this.initialized = false;

		this.defaultRoute = 'index';

		this.structure = {
			// local routes
			'index': {
				classes: '',
				action: window.initIndex
			},
			'whyus': {
				classes: 'is-inner',
				action: window.initWhyus
			},
			'solutions': {
				classes: 'is-inner',
				action: window.initSolutions
			},
			'about': {
				classes: 'is-inner',
				action: window.initAbout
			},
			'contacts': {
				classes: 'is-inner',
				action: window.initContacts
			},
			'search': {
				classes: 'is-inner',
				action: null
			},
			// remote routes
			'error': {
				classes: 'is-inner',
				action: null
			},
			'portfolio': {
				classes: 'is-inner',
				action: window.initPortfolio
			},
			'articles': {
				classes: 'is-inner',
				action: window.initArticle
			},
			'news': {
				classes: 'is-inner',
				action: null
			},
			'terms': {
				classes: 'is-inner',
				action: null
			},
			'shortcodegen': {
				classes: 'is-inner',
				action: null
			}
		};

		// ajax service for requesting pages via ajax
		this.ajaxService = ajaxService;

		/* search tags by selectors */
		this.parsedDomSelectors = this.parseDomSelectors();

		/* selectors */
		this.routeSelector = this.dataAttrWrap(routeSelectorMask) || `.route`;
		this.routePrefix = {selector: '#', propName: 'id'};
		this.containerSelector = this.dataAttrWrap(containerSelector) || `#routes`;		
		this.visibilityClass = `is-active`;

		/* body */
		this.body = document.body || document.getElementsByTagName('body')[0];

		this.updateRoutes();

		this.entryPoint = this.parseUrl();

		/* way of setting active route (via element itself or body) */
		this.activationType = 'body';

		/* set active route */
		const appliedParams = this.parseHash();
		this.setActive(this.entryPoint.path, this.getParamString(appliedParams));

		/* current route change */
		this.checkCurrentRouteMutate(this.entryPoint.path);

		/* override links */
		this.links = links ? links : linksContainer ? this.dqsa0(linksContainer, 'a') : linkSelector ? this.dqsa(`a${linkSelector}`) : []; 
		this.handleLinks(this.links);
		
		/* listen for address value change */
		this.handleUrlChanges();

		/* add / remove header shadow */
		this.setHeaderShadowHandlers();
	}

	parseDomSelectors(container = document) {
		const
			iterable = [],
			keyVal = {},
			prefixes = ['#', '.', 'data-'],	
			presumption = [
				'routes',
				'route',

			];

		presumption.forEach(body => {
			prefixes.forEach(prefix => {
				const
					selector = prefix.includes('data') ? this.dataSelect(body) : `${prefix}${body}`,
					{ length } = this.dqsa(selector);

				iterable.push({ length, selector });
				keyVal[selector] = length;
			});
		});

		iterable.sort((a, b) => b.length - a.length);

		return {
			iterable,
			keyVal,
		};
	}

	getCurrentRoute() {
		return this.parseUrl('path');
	}
	
	/* popstate event handler */
	handleUrlChanges() {
		window.onpopstate = (e) => {
			this.checkCurrentRouteMutate();
			const appliedParams = this.parseHash();
			this.applyHash(appliedParams);
			this.setActive(this.currentRoute, this.getParamString(appliedParams));

			// close search
			if ($('.search').hasClass('is-active')) {
				clearSearch();
			}
		}
	}

	checkCurrentRouteMutate(route = this.getCurrentRoute()) {
		this.currentRoute = route;
	}

	/* query selector */
	dqsa(s, container = document) {
		let result = [];

		try {
			result = Array.from(container.querySelectorAll(s));
		} catch (error) {
			console.log('dqsa error', error,);
			console.log('s, container', s, container);
		}

		return result;
	}

	dqsa0(s, childsFilter = false) {
		const
			all = this.dqsa(s),
			first = all[0];

		if (childsFilter) {
			const filterNodes = (nodes) => {
				// console.log('nodes', nodes);
				return nodes.filter(node => {
					return (node.tagName && node.tagName.toLowerCase() === childsFilter.toLowerCase());
				})
			};

			const
				childs = first.childNodes,
				childsArr = Array.from(first.childNodes),
				filteredNodes = filterNodes(childsArr);

			return filteredNodes;
		}

		return first;
	}

	/* common route change */
	go(route = '/') {		
		this.navigate(route);
		this.setActive(route);
	}

	/* parese routes to DOM */
	getRoutes(routeSelector = this.routeSelector, containerSelector = this.containerSelector) {
		const
			container = this.dqsa0(containerSelector),
			inContainer = this.dqsa(routeSelector, container),
			routesArray = inContainer.length ? inContainer : this.dqsa(routeSelector);
			
		var routesMap = {};
		routesArray.forEach((el) => {
			if (typeof el[this.routePrefix.propName] != 'undefined') {
				routesMap[el[this.routePrefix.propName]] = el;
			}
		});

		return [
			routesMap,
			container,
		];
	}

	redirect(path = '', state = null, title = '') {
		history.replaceState(state, title, path);
	}
	
	/* data attr selector */
	dataSelect(name = 'route', val = '') {
		return `[data-${name}${val ? `=${val}` : ''}]`;
	}

	/* working with data attr */
	dataAttrWrap(dataParam = '', paramVal = ''){
		let
			full = '',
			cleanDataParam = dataParam;

		if (cleanDataParam && cleanDataParam.includes) {
			if (cleanDataParam, paramVal) {
				if (cleanDataParam.includes('[') && cleanDataParam.includes(']')) {
					cleanDataParam = cleanDataParam.replace('[', '').replace(']', '');
				}
			}

			if (!cleanDataParam.includes('data-')) {
				return cleanDataParam;
			}

			if (paramVal) {
				full = `${cleanDataParam}="${paramVal}"`;

			} else {
				full = `${cleanDataParam}`;
			}
		}


		if (full.length && !(full.includes('[') && full.includes(']'))) {
			full = `[${full}]`;
		}
		return full;
	}

	getPageElementByRoute(route) {
		var el = this.routes[route];
		return typeof el === 'undefined' || el == null ? null : el;
	}

	/* set 1 active route */
	setActive(route, hash = '') {
		route = route == '/' || !route ? this.defaultRoute : route.replace(/^\//, '').replace(/\/$/, '');

		const 
			activeRoute = route.split('/')[0].split('-')[0],
			setting = this.structure[activeRoute],
			{ action, classes } = setting || this.structure["error"];

		// hide current page
		this.dqsa('.page.is-active').forEach(el => el.classList.remove('is-active'));

		if (!this.initialized && activeRoute != 'index') {
			this.initialized = true;
		}

		this.body.classList = `${this.initialized ? '' : `${'is-preloading is-first-loading'} `}page-${activeRoute}${classes ? ` ${classes}` : ''}`;

		// reorganize header
		this.removeHeaderShadow();
		this.removeMenuButtonActiveClass();
		this.removeSearchActiveClass();

		let page = this.getPageElementByRoute(route);
		if (page) {
			this.activate(page, action, $(page).attr('title'));
		} else {
			// page not found in html, request it via ajax
			this.ajaxService.getHtml('/gethtml/' + route + hash).done(res => {
				// remove current pages
				this.body.classList.add('is-ajaxloading');
				this.getPages().forEach(page => {
					this.removeNode(page);
				});

				// update to new page
				let result = this.attachPage(res);

				// result
				this.updateRoutes();
				this.handleLinks(this.dqsa('section.page:not(.shared) a'));

				// re-execute routing
				page = this.getPageElementByRoute(route);

				if (page == null) {
					// find first section
					// it may happen when routing id matches on server
					// but does not match on client
					// for example: news/2021-04-12
					// correct id: news/2021-4-12
					page = this.dqsa0('section');
				}

				this.activate(page, action, $(page).attr('title'));
				this.runScripts(route, result.querySelector('.js-article-content'));
			});
		}
		
		this.setHeaderShadowHandlers();
	}

	runScripts(route, container) {
		if (route != 'articles/visualising-neural-network-learning') {
			return;
		}

		let scriptPaths = [];
		
		container.querySelectorAll('script').forEach((item, i, arr) => {
			let dataSrc = item.src;

			scriptPaths.push(dataSrc);
		});

		scriptPaths.forEach((src, i, arr) => {
			let tag = document.createElement('script')
			tag.setAttribute('defer', 'defer');
			tag.src = src;
			container.appendChild(tag);
		});
	}

	activate(activeRouteElement, action, title) {
		const
			activeRouteDomNode = activeRouteElement;

		activeRouteDomNode.classList.add('is-active');
		this.body.classList.remove('is-ajaxloading');

		document.title = (title ? (title + " | ") : "") + "AESD Lab";

		this.setScrollTop();
		this.setScrollTop(activeRouteDomNode, 0);

		// re-initialize page scripts
		if (action != null) {
			action();
		}

		/* preloader flag */
		(!this.initialized && (this.initialized = true));

		window.logoPosition();	
		window.parallax();
        window.animateOnScroll();
		window.logoTransform();
		$('.wrapper')[0].scrollTo(0, 0);
	}

	/* destroy */
	destroy() {
		window.__CLIENT_ROUTER = null;
	}

	/* write to history */
	navigate(route, appliedParams, state = window.history.state, title = '') {
		window.history.pushState(state, title, route + this.getParamString(appliedParams));
	}

	/* handle all links */
	handleLinks(links = this.getLinks()) {
		links.forEach((link, i, all) => {
			const
				{ href } = link,
				relHref = link.getAttribute('href');
				
		if (relHref.includes('http')) return;

			link.addEventListener('click', (e) => {
				e.preventDefault();

				this.go(relHref);
			});
		});
	}

	getLinks(selector = document) {
		return this.dqsa('a', selector);
	}

	getPages() {
		return this.dqsa('section.page:not(.shared)');
	}

	removeNode(node) {
		node.parentNode.removeChild(node);
	}

	attachPage(page) {
		let elt = this.dqsa0('main.main');
		elt.insertAdjacentHTML('afterbegin', page);
		return elt;
	}

	updateRoutes() {
		/* go through DOM and collect routes */
		[this.routes, this.container] = this.getRoutes();
	}

	applyHash(appliedParams, route = this.getCurrentRoute()) {
		const hash = this.getParamString(appliedParams);
		this.redirect(`/${route}${hash}`);
	}

	getParamString(obj = {}) {
		let str = '';

		if (obj == null)
			return '';

		for (const key in obj) {			
			str += `${str.length ? '&' : ''}${key}=${obj[key]}`
		}

		if (str.length)
			return '?' + str;
		return str;
	}

	/* parse address value */
	parseUrl(param) {
		const
			{ pathname, search } = window.location,
			pathTrunc = pathname.substr(1),
			pathArr = pathTrunc.split('/'),
			depth = pathArr.length,
			path = pathTrunc,
			last = pathArr[pathArr.length - 1],
			setup = {
				path,
				last,
				depth,
				pathname,
				param: search,
			},
			result = param && setup.hasOwnProperty(param) ? setup[param] : setup;

		return result;
	}

	hide(el) {
		el.classList && el.classList['remove'](this.visibilityClass);
	}

	show(el) {
		el.classList && el.classList['add'](this.visibilityClass);
	}

	/* reverse class */
	toggleClass(el = this.body, _class = this.visibilityClass, propState) {
		const
			element = typeof el === 'string' ? this.dqsa0(el) : el,
			state = typeof propState !== _U ? propState : !this.hasClass(element, _class);

		element.classList && element.classList[state ? 'add' : 'remove'](_class);
	}

	toggleActivity(el) {
		this.toggleClass(el, this.visibilityClass)
	}

	hasClass(el = this.body, _class = this.visibilityClass) {
		return el.classList ? el.classList.contains(_class) : false;
	}

	/* retrieve params from address */
	parseHash(param = window.location.search) {
		const
			separators = ['#', '?', '&'],
			setup = {
			},
			sub = param.length && separators.includes(param[0]) ? param.substr(1) : param,
			pairs = sub.split('&');

		if (!sub.length)
			return setup;

		pairs.forEach(value => {
			let key, val;

			if (value.includes('=')) {
				const arr = value.split('=');

				key = arr[0];
				val = arr[1];
			} else {
				key = value;
				val = null;
			}

			setup[key] = val;
		});

		return setup;
	}

	/* remove active class from menu on route change */
	removeMenuButtonActiveClass() {
		this.body.classList.remove('is-overlay-menu');
	}

	removeSearchActiveClass() {
		this.body.classList.remove('is-overlay-search');
	}

	/* add / remove header shadow */
	setHeaderShadowHandlers() {
		let scrolled = document.querySelector('.wrapper').scrollTop;
		if (scrolled > 0 ) {
			this.body.classList.add('is-header-shadow');
		} else {
			this.body.classList.remove('is-header-shadow');
		}

		document.querySelector('.wrapper').onscroll = () => {
			let scrolled = document.querySelector('.wrapper').scrollTop;
			if (scrolled > 0 ) {
				this.body.classList.add('is-header-shadow');
			} else {
				this.body.classList.remove('is-header-shadow');
			}
		}
	}

	/* remove shadow on route change */
	removeHeaderShadow() {
		this.body.classList.remove('is-header-shadow');
	}

	/* set scroll to 0 on route change */
	setScrollTop(node = this.body, value = 0) {
		node.scrollTop = value;
	}
}

/* ... . .-. --. . / --.. .... ..- .-. .- ...- .-.. . ...- */

/* router init */
const createRouter = (...all) => {
	if (typeof window.__CLIENT_ROUTER === _U) {
		window.__CLIENT_ROUTER = new Router(...all);
	}
	
	return window.__CLIENT_ROUTER;
}